import { TClaims } from "@page-builder/ts/generated";
import React, { useMemo } from "react";
import styles from "./styles.module.scss";
import { callEvent } from "src/api";
import { useDomainContext } from "@hooks/useDomainContext";
import { useCallCampaignContext } from "@hooks/useCallCampaignContext";
import { formatPhoneNumber, getPhoneNumber } from "@lib/sharedUtils";
import Spinner from "@components/shared/spinner";
import { replacePlaceholders } from "@lib/sharedUtils";
import CallIcon from "@components/shared/callsCampaign/callIcon";
import CallsCampaignRecaptcha from "@components/shared/callsCampaignRecaptcha";

const Claims = ({ props = {} }: { props?: TClaims["props"] }) => {
    const { category, headerOffer, visitDetails, domain, formattedTitle } =
        useDomainContext();
    const { showPhoneNumber } = useCallCampaignContext();

    let phoneNumber: string | undefined;
    if (category && headerOffer?.length) {
        phoneNumber = getPhoneNumber(headerOffer[0]);
    } else {
        phoneNumber = "";
    }
    const show = true;
    const sellingPoint = props.sellingPoint
        ? replacePlaceholders(props.sellingPoint, {
              category: category?.name,
              region: visitDetails?.region,
              city: visitDetails?.city,
          })
        : undefined;
    const getRecaptcha = useMemo(() => {
        if (
            visitDetails?.trafficSourceNetwork?.toLocaleLowerCase() === "bing"
        ) {
            return <CallsCampaignRecaptcha />;
        }
        return <></>;
    }, [visitDetails]);

    const title1 =
        domain?.textBlocks?.find(
            (block) => block.position === "calls-campaign-title",
        )?.text ||
        formattedTitle ||
        "Injured in a Car Accident?";

    const title2 =
        domain?.textBlocks?.find(
            (block) => block.position === "calls-campaign-sub-title",
        )?.text || "You May Qualify for Significant Compensation";

    const description =
        domain?.textBlocks?.find(
            (block) => block.position === "calls-campaign-description",
        )?.text || "Call us now for a 100% Free Consultation";

    return (
        <section className={`${styles["claims-container"]}`}>
            {getRecaptcha}
            <div className={`${styles["claims-inner"]}`}>
                {/* <div
                    dangerouslySetInnerHTML={{
                        __html: props.text
                            ? replacePlaceholders(props.text, {
                                  category: category?.name,
                                  region: visitDetails.region,
                                  city: visitDetails?.city,
                              })
                            : "",
                    }}
                    className={`prose md:prose-md max-w-none ${styles["text-block"]}`}
                /> */}
                <div>
                    <div
                        className={`${styles["title"]} text-2xl md:text-4xl font-bold text-center`}
                        dangerouslySetInnerHTML={{
                            __html: replacePlaceholders(title1, {
                                category: category?.name,
                                region: visitDetails.region,
                                city: visitDetails?.city,
                            }),
                        }}
                    />
                    <div
                        className={`${styles["sub-title"]} mt-3 md:mt-5 text-lg md:text-xl font-bold text-center`}
                        dangerouslySetInnerHTML={{
                            __html: replacePlaceholders(title2, {
                                category: category?.name,
                                region: visitDetails.region,
                                city: visitDetails?.city,
                            }),
                        }}
                    />
                </div>
                <p
                    className={`${styles["description"]} text-base md:text-lg mt-5 mb-8 md:mb-10 text-center`}
                    dangerouslySetInnerHTML={{
                        __html: replacePlaceholders(description, {
                            category: category?.name,
                            region: visitDetails.region,
                            city: visitDetails?.city,
                        }),
                    }}
                />
                {((phoneNumber || props.phoneNumber) && showPhoneNumber) ||
                show ? (
                    <div className={`${styles["button-with-note"]}`}>
                        <a
                            className={`${styles["button"]} ${
                                props.buttonAnimation
                                    ? `${styles["animation"]}`
                                    : ``
                            }`}
                            href={`tel:${
                                props.phoneNumber ?? (phoneNumber as string)
                            }`}
                            onClick={() => {
                                void callEvent({
                                    event: "Call",
                                    phoneNumber: phoneNumber as string,
                                });
                            }}
                        >
                            {props.buttonIcon && <CallIcon />}
                            <span>
                                {formatPhoneNumber(
                                    props.phoneNumber ||
                                        phoneNumber ||
                                        "9999999999",
                                )}
                            </span>
                        </a>
                        {props.buttonNote && (
                            <label>
                                {replacePlaceholders(props.buttonNote, {
                                    category: category?.name,
                                    region: visitDetails?.region,
                                    city: visitDetails?.city,
                                })}
                            </label>
                        )}
                    </div>
                ) : (
                    <div className="flex items-center justify-center">
                        <Spinner size={50} color={""} success={false} />
                    </div>
                )}
                {sellingPoint && (
                    <div className={`${styles["sellingPoint"]}`}>
                        {sellingPoint}
                    </div>
                )}
            </div>
        </section>
    );
};

export default Claims;
